import {generateVectorPosition} from "../../../../client/utils/vector-position";

class Image_doodles{
    constructor() {
        this.element = [
            document.querySelector('.single-blog-press-template #ecf-masthead-gen .box-img-masthead'),
            document.querySelector('.single-blog-press-template .ecf-we-do .background-img-position'),
            document.querySelector('.single-blog-press-template .single-blog-press-template__content .box-img')
        ]
    }

    init(){
        let elements = this.element
        if(elements.length > 0){
            for(let item of elements){
                if(item){
                    let imgs = Array.prototype.slice.call(item.querySelectorAll('img'));
                    imgs.forEach(element => {
                        let dataPosition = element.getAttribute('data-position');
                        let dataResponsive = element.getAttribute('data-responsive');
                        let defaultObj = JSON.parse(atob(dataPosition))
                        let responsive = atob(dataResponsive)
                        generateVectorPosition(defaultObj, responsive, element);
                    });
                }
            }
        }
    }
}

export default  Image_doodles